/**
 * uses from config the origins object that includes preconnect:boolean and endpoints:string[]
 * @param configOrigins
 */
export const preconnectToOrigins = (configOrigins?: any) => {
    // check if configOrigins is defined and has preconnect:boolean as true
    if (configOrigins && configOrigins.preconnect) {
        configOrigins.endpoints?.forEach(endpoint => {
            const link = document.createElement('link')
            link.rel = 'preconnect'
            link.href = endpoint
            link.crossOrigin = 'anonymous'
            document.head.appendChild(link)
        })
    }
}
